"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chains = exports.rawChains = void 0;
const kusama_chains_1 = require("./kusama-chains");
const polkadot_chains_1 = require("./polkadot-chains");
exports.rawChains = {
    ...kusama_chains_1.kusamaChains,
    ...polkadot_chains_1.polkadotChains,
};
exports.chains = exports.rawChains;
